import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';

export function OSServiceVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="service-vehicle-os"
      data-testid={testIds.vehicles.serviceVehicleOpenSearch()}
      // eslint-disable-next-line no-restricted-syntax
      key="service-vehicle-opensearch"
      actionCallback={actionCallback}
    />
  );
}
